import { Component, ElementRef, HostListener, EventEmitter, Input, Output, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationExtras, ActivatedRoute } from '@angular/router';

import { FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

import { MyErrorHandler } from '../../../../../tools/src/lib/errorhandler/errorhandler';
import { Grade, Year, Class, Subject } from '../../../../../schoolmanagement/src/app/model/school.model';
import { I18nPluralPipe } from '@angular/common';

declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-ctl-sch-classgroup-form',
  templateUrl: './ctl.school.classgroup.component.html',
  styleUrls: ['./ctl.school.classgroup.component.css']
})


export class ClassGroupComponent implements OnInit {

  @Input() viewType;
  @Input() myClass: any;
  @Input() myForm: FormGroup;
  @Input() groupData: any;
  @Input() myStudentsList = [];
  @Input() mySelectedStudents = [];

  @Output() evFormUpdate: EventEmitter<boolean> = new EventEmitter();
  @Output() evCheckUpdate: EventEmitter<boolean> = new EventEmitter();
  noOfSubjects = 0;
  @Input() selectedStudents = [];
 textDir:any;
  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute) {
      this.textDir = sessionStorage.getItem('textDir');
  }

  ngOnInit() {

  }

  ngDoCheck() {
    //
    if (!this.groupData && !this.myForm.controls.name) {
      this.selectedStudents = new Array();
    }
  }

  countSelectedSubject() {
    //
  }

  isChecked(data) {
//
  if (this.selectedStudents && this.selectedStudents.find(x => x === data._id) ) {
      return true;
    } else {
      return false;
    }
  }

  checkUncheckSubject(item,event) {
    //
      console.log('check uncheck' + JSON.stringify(event.target.checked));

      if(event.target.checked){
        if (this.selectedStudents && this.selectedStudents.indexOf(item._id) === -1) {
          this.selectedStudents.push(item._id);
        }
      }else{
        if (this.selectedStudents && this.selectedStudents.length && this.selectedStudents.indexOf(item._id) !== -1 ) {
          this.selectedStudents.splice(this.selectedStudents.indexOf(item._id), 1);
        }
      }
      this.myForm.controls.students.patchValue(this.selectedStudents);
      console.log('after check uncheck' + JSON.stringify(this.selectedStudents.length));
      if(this.selectedStudents.length != 0){
        this.evCheckUpdate.emit(true)
      }else{
        this.evCheckUpdate.emit(false)
      }
  }

  selectAll() {
    //
    this.deselectAll();
    this.myStudentsList.forEach(item => {
      this.selectedStudents.push(item._id);
    });
    this.myForm.controls.students.patchValue(this.selectedStudents);
    console.log("select all - group - " + JSON.stringify(this.myForm.value));
  }

  deselectAll() {
    //
    this.selectedStudents = new Array();
    this.myForm.controls.students.patchValue(this.selectedStudents);
    console.log("deselect all - group - " + JSON.stringify(this.myForm.value));
  }

  formChange() {
    this.evFormUpdate.emit(true);
  }
  ngOnDestroy() {
    const body = document.getElementsByTagName('body')[0];
    body.classList.remove('bodyBG');
  }

}
